import { Person, PersonRole } from "types/Models/apAutofills";
import { Shareholder } from "types/Models/Shareholders";

export const buildShareholderRole = (shareholder: Shareholder): PersonRole => ({
  join_id: `shareholder-${shareholder.uuid}`,
  persona_type: "SHAREHOLDER",
  ap_status: "ACTIVE",
  is_authorised_signatory: false,
  ownership_stake: shareholder.ownership_stake,
  shareholder_country: shareholder.country?.name || null,
});

export const mergePersonAndShareholder = (
  person: Person | undefined | null,
  shareholder: Shareholder | undefined | null
): Person | null => {
  if (person && shareholder) {
    return {
      ...person,
      roles: [...person.roles, buildShareholderRole(shareholder)],
    };
  }
  if (person) {
    return person;
  }
  if (shareholder?.persona_details) {
    const personaDetails = shareholder.persona_details;
    return {
      persona_autofill_id: personaDetails.persona_autofill_id,
      first_name: personaDetails.first_name,
      last_name: personaDetails.last_name,
      email: personaDetails.email,
      phone_number: personaDetails.phone_number,
      country: personaDetails.country,
      tax_residency: personaDetails.tax_residency,
      address: personaDetails.address,
      is_authorised_signatory: false,
      roles: [buildShareholderRole(shareholder)],
    };
  }
  return null;
};
